import loadScript from "@hooks/useWebsiteBuilder/functions/loadScript";
import type { App } from "@hooks/useWebsiteBuilder/index";
import grapesjs from "grapesjs";
import type { EditorConfig } from "grapesjs";
import grapesjsRulers from "grapesjs-rulers";

export async function loadGrapesJsScripts(apps: App[], opt: Parameters<typeof loadScript>[1] = {}) {
  const _scriptUrls = apps
    .map((app) => {
      return app.url;
    })
    .filter((e) => e) as string[];

  try {
    await loadScript([..._scriptUrls, "https://unpkg.com/grapesjs-rulers"], opt);
  } catch { }
}

export function getGrapesEditorInstance({
  height = "100%",
  width = "100%",
  jsInHtml = true,
  allowScripts = 1,
  showOffsets = true,
  dragMode = "absolute",
  readOnly = false,
  fromElement = true,
  apps,
  pluginsOpts,
  ...props
}: Omit<EditorConfig, "plugins"> & { apps: App[], allowScripts?: 0 | 1, pluginsOpts?: Record<string, any>, readOnly?: boolean }) {
  const plugins = [
    ...apps
      .map((app) => app.id)
      .filter((e) => e) as string[],
    'grapesjs-rulers',
  ];

  function makeReadonly() {
    editor.getModel().set('canvasscripts', []);

    editor.Panels.getPanels().forEach((p: any) => p.set('visible', false));

    // Disable selection and hover events
    editor.getWrapper()?.set('editable', false);
    const frameEl = editor.Canvas.getFrameEl();
    if (frameEl)
      frameEl.style.pointerEvents = 'none';
  }

  const editor = grapesjs.init({
    ...props,
    height,
    width,
    // @ts-ignore
    allowScripts,
    showOffsets,
    dragMode,
    fromElement,
    plugins,
    pluginsOpts: {
      ...plugins.reduce((a, v) => ({ ...a, [v]: pluginsOpts }), {}),
    },
  })

  if (readOnly) {
    setTimeout(makeReadonly, 1000);
  }

  return editor;
}
